import { Box, Typography, Button, SxProps, Theme, Link } from "@mui/material";
import { SectionTitle } from "src/modules/SectionTitle/SectionTitle";
import { SectionContainer } from "src/modules/SectionContainer/SectionContainer";

export const Cta = () => {
  return (
    <SectionContainer sx={{ background: "#22A1B9" }}>
      <SectionTitle sx={{ color: "#FFFFFF" }}>システム開発の課題を解決しませんか？</SectionTitle>
      <Typography variant="body1" sx={descriptionSx}>
        テクニカルアシストサービス（TAS）で、最適なチーム構成と柔軟な開発体制を実現しましょう。
        お客様のプロジェクトに合わせた最適なプランをご提案いたします。
      </Typography>
      <Box sx={buttonBoxSx}>
        <Button variant="contained" sx={ctaButtonSx} component={Link} href="/#Contact">
          無料相談・お問い合わせ
        </Button>
      </Box>
    </SectionContainer>
  );
};

const descriptionSx: SxProps<Theme> = {
  fontSize: "20px",
  lineHeight: 1.6,
  marginBottom: "20px",
  color: "#FFFFFF",
  opacity: 0.9,
};

const buttonBoxSx: SxProps<Theme> = {
  display: "flex",
  gap: "20px",
  justifyContent: "center",
  flexWrap: "wrap",
};

const ctaButtonSx: SxProps<Theme> = {
  background: "white",
  color: "#22A1B9",
  padding: "15px 40px",
  borderRadius: "30px",
  fontWeight: 600,
  transition: "all 0.3s ease",
  boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
  "&:hover": {
    transform: "translateY(-3px)",
    boxShadow: "0 12px 25px rgba(0,0,0,0.3)",
    background: "white",
  },
};
